
























































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormFile,
  VBTooltip,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { PrestationAdditionnelleCreateModel } from "@/api/models/prestationsAdditionnelles/prestationAdditionnelle";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormDatepicker,
    BFormFile,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  name: "create-prestation-additionnelle",
})
export default class CreatePrestationAdditionnelle extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewPrestationAdditionnelleSidebarActive!: boolean;
  loading = false;

  required = required;

  listTypePrestationAdditionnelle = [];

  totalCountTypePrestationAdditionnelle = 0;

  newPrestationAdditionnelle: PrestationAdditionnelleCreateModel = {};

  async created() {
    await this.getTypePrestationAdditionnelle();
  }

  resetForm() {
    this.newPrestationAdditionnelle = {};
  }

  async getTypePrestationAdditionnelle() {
    await this.$http.myressif.parametres
      .getByNom("type_prestation_additionnelle_adherent")
      .then((res: any) => {
        this.listTypePrestationAdditionnelle = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .createPrestationAdditionnelleOnEntreprise(this.$route.params.id, this.newPrestationAdditionnelle)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'une prestation additionnelle",
            text: "Prestation additionnelle créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-prestation-additionnelle");
        this.$emit("update:is-add-new-prestation-additionnelle-sidebar-active", false);
        this.loading = false;
      });
  }
}
